import { TextInput } from 'shared-ui/lib/components/customs/form/TextInput';
import { FormInput } from 'shared-ui/lib/customs/form/FormInput';
import { YupNullableNumber } from 'shared-ui/lib/utils/yup-nullable-number';
import * as Yup from 'yup';

const lockedNameClassName =
  'cursor-not-allowed [&_*]:cursor-not-allowed [&_label]:text-gray-600 [&_input]:pointer-events-none [&_input]:bg-gray-200 [&_input]:text-gray-600 [&_input]:border-gray-400 [&_input]:shadow-none';

const OfficialNameInput = () => (
  <div className={lockedNameClassName}>
    <fieldset disabled className="m-0 min-w-0 border-0 p-0">
      <TextInput name="officialName" label="ServiceCallApplyScene:officialName" type="text" />
    </fieldset>
  </div>
);

const businessId: FormInput = {
  type: 'text',
  initValue: '',
  validation: Yup.string().required(),
  props: {
    name: 'businessId',
    type: 'text',
    label: 'ServiceCallApplyScene:businessId',
  },
};

const officialName: FormInput = {
  type: 'element',
  props: {
    type: 'element',
    name: 'officialName',
    Element: OfficialNameInput,
  },
};

const streetAddress: FormInput = {
  type: 'text',
  initValue: '',
  validation: Yup.string().required(),
  props: {
    name: 'streetAddress',
    type: 'text',
    label: 'ServiceCallApplyScene:streetAddress',
  },
};

const postalCode: FormInput = {
  type: 'text',
  initValue: '',
  validation: Yup.string().required(),
  props: {
    name: 'postalCode',
    type: 'text',
    label: 'ServiceCallApplyScene:postalCode',
  },
};

const city: FormInput = {
  type: 'text',
  initValue: '',
  validation: Yup.string().required(),
  props: {
    name: 'city',
    type: 'text',
    label: 'ServiceCallApplyScene:city',
  },
};

const contactName: FormInput = {
  type: 'text',
  initValue: '',
  validation: Yup.string().required(),
  props: {
    name: 'contactName',
    type: 'text',
    label: 'ServiceCallApplyScene:contactName',
  },
};

const phone: FormInput = {
  type: 'text',
  initValue: '',
  validation: Yup.string().required(),
  props: {
    name: 'phone',
    type: 'text',
    label: 'ServiceCallApplyScene:phone',
  },
};

const email: FormInput = {
  type: 'select',
  initValue: '',
  validation: Yup.string().email().required(),
  props: {
    name: 'email',
    label: 'ServiceCallApplyScene:email',
    options: [],
  },
};

const industry: FormInput = {
  type: 'textarea',
  initValue: '',
  validation: Yup.string().required(),
  props: {
    name: 'industry',
    label: 'ServiceCallApplyScene:industry',
  },
};

const personnelCount: FormInput = {
  type: 'text',
  initValue: '',
  validation: YupNullableNumber,
  props: {
    name: 'personnelCount',
    type: 'number',
    label: 'ServiceCallApplyScene:personnelCount',
  },
};

export const serviceCallApplicationInputs = {
  businessId,
  officialName,
  streetAddress,
  postalCode,
  city,
  contactName,
  phone,
  email,
  industry,
  personnelCount,
};
